import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ProgressBarModule } from 'primeng/progressbar';

@NgModule({
  declarations: [FileUploadComponent],
  imports: [CommonModule, ButtonModule, RippleModule, ProgressBarModule],
  exports: [FileUploadComponent],
})
export class FileUploadModule {}
